import React from 'react';
import { observer } from 'mobx-react';
import VocabularyListService from '../services/VocabularyListService';
import VocabularyListFilter from './VocabularyListFilter';

const VocabularyListFilterContainer = () => (
  <VocabularyListFilter
    onChange={VocabularyListService.form.setValue}
    onSearch={VocabularyListService.load}
    values={VocabularyListService.form.getValues()}
  />
);

export default observer(VocabularyListFilterContainer);
